import React, { useState, useEffect } from "react";
import axios from "axios";
import { useStateValue } from "../../../StateProvider";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  Skeleton,
} from "@mui/material";
import PressReleasesContainer from "./PressReleasesContainer";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  label: {},
  data: {},
});
const OverviewContainer = ({ companyData, stockData }) => {
  const [{ token }] = useStateValue();
  const [news, setNews] = useState([]);
  const [logo, setLogo] = useState([]);
  const [totalNewsToShow, setTNTS] = useState(4);
  const [disableSeeMore, SetDisableSeeMore] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${companyData?.symbol}/logo?token=${token}`
      )
      .then((res) => {
        // console.log("logo", res.data);
        setLogo(res.data?.url);
      })
      .catch((err) => console.log(err));
    // console.log("stock data", stockData);
    /************news */

    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${companyData?.symbol}/news/last/5?token=${token}`
      )
      .then((res) => {
        console.log("response news", res.data);
        setNews(res.data);
      })
      .catch((err) => console.log(err));
  }, [companyData]);

  const classes = useStyles();
  /********press */
  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${companyData?.symbol}/news/last/20?token=${token}`
      )
      .then((res) => {
        console.log("news", res?.data);
        setNews(res?.data);
        setIsLoading(false);
      });
  }, [companyData]);
  const seeMore = () => {
    const length = news?.length;
    // console.log("seemore", length, totalStocksToShow);
    if (length - totalNewsToShow < 4) {
      setTNTS(length - 1);
      SetDisableSeeMore(true);
    } else {
      setTNTS(totalNewsToShow + 4);
    }
  };
  return (
    <Grid
      container
      sx={{
        gap: { md: "20px", sm: "10px" },
        color: "fontPrimaryColor.main",
        padding: "10px",
        // border: "1px solid rgb(230, 235, 241)",
        borderRadius: "8px",
        backgroundColor: "bgPrimary.main",
      }}
      spacing={0}
      className="overview__page"
    >
      <Grid
        item
        xs={12}
        md={8}
        // bgcolor="#ffffff"
        sx={{ borderRadius: "8px", padding: { md: "5px 10px" } }}
      >
        {}
        <Box className="overview__container">
          <Box className="logo__wrapper">
            <img src={logo} />
          </Box>
          <Box className="main__content">
            <Box
              sx={{ color: "fontPrimaryColor.main" }}
              className="company__name"
            >
              {companyData?.companyName}
            </Box>
            <p className="description">{companyData?.description}</p>
            <Box className="address__container">
              <Box
                sx={{
                  color: "fontPrimaryColor.main",
                  fontSize: "0.8rem",
                  marginBottom: "6px",
                }}
              >
                Address
              </Box>
              <p>{companyData?.address ? companyData?.address : "N/A"}</p>
              <p>{companyData?.city}</p>
              <p>{companyData?.state}</p>
              <p>{companyData?.country}</p>
            </Box>
            <Box className="phone">
              <Box
                sx={{
                  color: "fontPrimaryColor.main",
                  fontSize: "0.8rem",
                  marginBottom: "6px",
                }}
              >
                Phone
              </Box>
              <p>{companyData?.phone ? companyData?.phone : "N/A"}</p>
            </Box>
            <Box className="exchange">
              <Box
                sx={{
                  color: "fontPrimaryColor.main",
                  fontSize: "0.8rem",
                  marginBottom: "6px",
                }}
              >
                Exchange
              </Box>
              <p> {companyData?.exchange ? companyData?.exchange : "N/A"}</p>
            </Box>
            <Box className="industry">
              <Box
                sx={{
                  color: "fontPrimaryColor.main",
                  fontSize: "0.8rem",
                  marginBottom: "6px",
                }}
              >
                Sector
              </Box>
              <p> {companyData?.sector ? companyData?.sector : "N/A"}</p>
            </Box>
            <Box className="industry">
              <Box
                sx={{
                  color: "fontPrimaryColor.main",
                  fontSize: "0.8rem",
                  marginBottom: "6px",
                }}
              >
                Industry
              </Box>
              <p> {companyData?.industry ? companyData?.industry : "N/A"}</p>
            </Box>
            <Box className="employees">
              <Box
                sx={{
                  color: "fontPrimaryColor.main",
                  fontSize: "0.8rem",
                  marginBottom: "6px",
                }}
              >
                Employees
              </Box>
              <p> {companyData?.employees ? companyData?.employees : "N/A"}</p>
            </Box>
            <Box className="zip">
              <Box
                sx={{
                  color: "fontPrimaryColor.main",
                  fontSize: "0.8rem",
                  marginBottom: "6px",
                }}
              >
                Zip
              </Box>
              <p> {companyData?.zip ? companyData?.zip : "N/A"}</p>
            </Box>
            {companyData?.website && (
              <Box className="website">
                <Box
                  sx={{
                    color: "fontPrimaryColor.main",
                    fontSize: "0.8rem",
                    marginBottom: "6px",
                  }}
                >
                  Website
                </Box>
                {}
                <p>
                  {" "}
                  <a
                    href={"https://" + companyData?.website}
                    target="_blank"
                    style={{ fontSize: "1rem" }}
                  >
                    {companyData?.website}
                  </a>
                </p>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={3} sx={{ marginTop: "30px" }}>
        {/* {companyData && <PressReleasesContainer specificFor={companyData} />} */}
        <Box className="press__releases__container" sx={{ padding: "10px 0" }}>
          <Typography
            variant="h5"
            component="div"
            sx={{
              fontWeight: 600,
              fontSize: "0.8rem",
              fontFamily: "Public Sans,sans-serif",
              marginBottom: "20px",
            }}
          >
            <>{`Latest News For ${companyData?.companyName}`}</>
          </Typography>
          <Box
            sx={{
              width: "100%",
              padding: "20px 5px",
              //   border: "1px solid #000",
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              backgroundColor: "bgPrimary.main",
            }}
          >
            {isLoading ? (
              <>
                {new Array(4).fill("x", 0, 3).map((a) => (
                  <Box
                    sx={{
                      width: "250px",
                      background: "white",
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid rgb(230, 235, 241)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <Skeleton variant="rounded" width={"100%"} height={80} />
                    <Skeleton
                      variant="text"
                      width={"50%"}
                      height={20}
                      sx={{ margin: "0 10px 0px 10px" }}
                    />
                    <Skeleton
                      variant="rounded"
                      width={"80%"}
                      height={30}
                      sx={{ margin: "0 10px 10px 10px" }}
                    />
                  </Box>
                ))}
              </>
            ) : (
              <>
                {news?.slice(0, totalNewsToShow)?.map(
                  (n) =>
                    n?.image && (
                      <Box
                        sx={{
                          width: "250px",
                          background: "white",
                          borderRadius: "8px",
                          overflow: "hidden",
                          border: "1px solid rgb(230, 235, 241)",
                          backgroundColor: "bgPrimary.main",
                        }}
                      >
                        {n?.image && (
                          <img
                            className="thumbnail"
                            src={n?.image}
                            style={{ width: "100%", height: "120px" }}
                          />
                        )}

                        <Typography
                          sx={{
                            fontFamily: "Public Sans",
                            fontSize: "0.7rem",
                            fontWeight: "300",
                            padding: "8px",
                          }}
                        >
                          {new Date(n?.datetime).toDateString()} . {n?.source}
                        </Typography>
                        <a
                          href={n?.url}
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "#262626",
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Public Sans",
                              fontSize: "0.875rem",
                              padding: "8px",
                              fontWeight: "600",
                              color: "fontPrimaryColor.main",
                            }}
                          >
                            {n?.headline}
                          </Typography>
                        </a>
                      </Box>
                    )
                )}
              </>
            )}
          </Box>
          {!isLoading && !disableSeeMore && (
            <>
              <button
                style={{
                  marginLeft: "5px",
                  padding: "6px 15px",
                  cursor: "pointer",
                  backgroundColor: "#052728",
                  color: "white",
                  border: "1px solid #f6f6f6",
                  borderRadius: "15px",
                  fontFamily: "public sans",
                  fontSize: "0.75rem",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => seeMore()}
              >
                {" "}
                See More
              </button>
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default OverviewContainer;
